<template>
  <div id="secondary-trade-info-modal">
    <div class="tw-flex tw-justify-center">
      <img src="@/assets/img/orange-info.svg" alt="info" />
    </div>
    <div v-if="type === 'tradeInfo'">
      <div class="tw-mt-6">
        <h3 class="tw-text-xl tw-text-center tw-font-bold">
          {{ header }}
        </h3>
        <p class="tw-text-black-light tw-text-center tw-mt-2">
          {{ subHeader }}
        </p>
      </div>
      <div class="tw-mt-8">
        <div v-for="(detail, index) in details" :key="index" class="tw-mb-8">
          <div class="tw-flex tw-font-bold tw-mb-1">
            <img
              class="tw-mr-4"
              src="@/assets/img/success-mark.svg"
              alt="info"
            />
            <h3>{{ detail.header }}</h3>
          </div>
          <p class="tw-text-black-light tw-text-sm tw-ml-9">
            {{ detail.text }}
          </p>
        </div>
      </div>
      <Btn class="tw-mt-8" title="I Understand" @click="$emit('close')" />
    </div>
    <div v-if="type === 'marketTrade'">
      <div class="tw-mt-6">
        <h3 class="tw-text-xl tw-text-center tw-font-bold">
          {{ header }}
        </h3>
      </div>
      <div class="tw-mt-8">
        <h3 class="tw-font-bold tw-underline tw-mb-4">Please note:</h3>
        <div v-for="(detail, index) in details" :key="index" class="tw-mb-8">
          <div class="tw-flex tw-items-center tw-font-bold tw-mb-1">
            <div
              class="tw-w-8 tw-h-8 tw-flex tw-justify-center tw-items-center tw-rounded-full tw-bg-success tw-px-4 tw-mr-4"
            >
              <p class="tw-text-white">{{ index + 1 }}</p>
            </div>
            <p class="tw-text-black-light tw-text-sm">
              {{ detail.text }}
            </p>
          </div>
        </div>
      </div>
      <Btn
        class="tw-mt-8"
        title="I Understand, Proceed"
        @click="$emit('close')"
      />
    </div>
  </div>
</template>

<script>
import Btn from "@/components/general/BtnComponent.vue";

export default {
  name: "SecondaryTradeInfoModal",

  components: { Btn },

  props: {
    header: { type: String, default: () => "", required: true },
    subHeader: { type: String, default: () => "", required: true },
    details: { type: Array, default: () => [], required: true },
    type: { type: String, default: () => "", required: true },
    // label: { type: String, default: () => "", required: true },
    // name: { type: String, default: () => "", required: true },
    // inputName: { type: String, default: () => "", required: true },
    // error: { type: Object, default: () => {} },
    // isRequired: { type: Boolean, default: () => true },
  },
};
</script>

<style lang="scss" scoped></style>
